import React, { useEffect, useMemo, useState } from 'react'
import styles from '../quiz/quiz.module.css'
import { Action, AnswerKey, Darkmenu, DeleteIcon, EditIcon, Info, LightDelete, Lightedit, Menu, Next, Opened, Plusicon, Preview, RightArrow, Search, Status, Table } from '../../svg'
import { Button, MenuItem, Select } from '@mui/material'
import { custom, customradius, formselect, save, saveradius, selectInput } from '../MaterialUI'
import { useNavigate, useSearchParams, useParams } from 'react-router-dom'
import Api from '../../helper/api'
import BasicInfo from './BasicInfo'
import QA from './QA'
import FinalPreview from './Preview'


const EditQuiz = () => {
    const navigate = useNavigate();
    const api = new Api();
    const params = useParams();

    // states -----------------
    // ------------------------
    const [id, setId] = useState(null);
    const [course, setCourse] = useState({
        subjects: [],
        topics: [],
        chapters: [],
        levels: []
    });
    const [title, setTitle] = useState(1)

    useEffect(() => {
        fetchCourse();
    }, [params.id]);

    const fetchCourse = async () => {
        try {
            const { data, status } = await api.getAllCourse();

            if (status === 200) {
                setCourse(data.data)
                setId(params.id)
            }
        } catch (err) {
            console.log(err)
        }
    }

    const handleClick = (id) => {
        setTitle(id)
    }

    const handleCancel = () => {
        navigate('/qa/quiz')
    }
    return (
        <div className={styles.container}>
            <div className={styles.head}>
                <h1>Edit Q&A</h1>
                <span>
                    home <RightArrow /> quiz Management <RightArrow /> <span style={{ color: 'var(--Gray-900, #191B1C)' }}>Edit quiz</span>
                </span>
                <div style={{ position: 'absolute', top: '33px', right: '27px' }}>
                    <Button sx={save} onClick={() => navigate('/qa/quiz')} variant="contained">Back to table</Button>
                </div>
            </div>
            <div className={styles.maincontainer}>
                <div style={{ display: 'flex', gap: '24px' }}>
                    <div onClick={() => handleClick(1)} className={title === 1 ? `${styles.title} ${styles.activeTitle}` : styles.title}>
                        <span>
                            <Info /> Basic information
                        </span>
                        {
                            title > 1 && <img src="/assets/icons/check.svg" style={{ float: "right" }} />
                        }
                    </div>
                    <div onClick={() => handleClick(2)} className={title === 2 ? `${styles.title} ${styles.activeTitle}` : styles.title}>
                        <span>
                            <Table /> Q & A
                        </span>
                        {
                            title > 2 && <img src="/assets/icons/check.svg" style={{ float: "right" }} />
                        }
                    </div>
                    <div onClick={() => handleClick(3)} className={title === 3 ? `${styles.title} ${styles.activeTitle}` : styles.title}>
                        <span>
                            <Preview />preview
                        </span>
                    </div>
                </div>

                {
                    title === 1 &&
                    <BasicInfo
                        course={course}
                        id={id}
                        setId={setId}
                        setTitle={setTitle}
                        handleCancel={handleCancel}
                    />
                }
                {
                    title === 2 &&
                    <QA
                        id={id}
                        setTitle={setTitle}
                        handleCancel={handleCancel}
                    />
                }
                {
                    title === 3 &&
                    <FinalPreview
                        course={course}
                        setTitle={setTitle}
                        id={id}
                        handleCancel={handleCancel}
                    />
                }
            </div>
        </div>
    )
}

export default EditQuiz
